import React from "react";
import TextField from "@mui/material/TextField";
import { DamsInputProps } from ".";
import { Stack, Typography } from "@mui/material";

const ItemInput: React.FC<DamsInputProps> = ({
  label = "Text label",
  size = "short",
  placeholder = "Placeholder",
  name,
  handleChange,
  value,
  error,
  errorMessage,
  multiline,
  rows,
  required = false,
  type = "text",
}) => {
  const InputSize =
    size === "long"
      ? { width: 512, height: multiline ? "auto" : 75 }
      : size === "full"
      ? { width: "100%", height: multiline ? "auto" : 75 }
      : { width: 260, height: multiline ? "auto" : 75 };

  return (
    <Stack width={InputSize.width} height={InputSize.height} gap={0.3}>
      <Typography
        fontFamily={"Inter"}
        fontWeight={500}
        fontSize={14}
        color={"#344054"}
      >
        {label}
        {required && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
      </Typography>

      <TextField
        placeholder={placeholder}
        variant="outlined"
        fullWidth
        sx={styles.inputProps}
        name={name}
        onChange={handleChange}
        value={value}
        type={type}
        inputProps={
          type === "number"
            ? {
                inputMode: "numeric" as const,
                pattern: "[0-9]*",
              }
            : undefined
        }
        multiline={multiline}
        rows={rows ?? 6}
        required={required}
      />
      {error && (
        <Typography variant="caption" color={"red"} sx={{ marginLeft: 1 }}>
          {errorMessage}
        </Typography>
      )}
    </Stack>
  );
};

const styles = {
  inputProps: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#D0D5DD",
        borderRadius: "8px",
      },
      "&:hover fieldset": {
        borderColor: "#D0D5DD",
        borderRadius: "8px",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#D0D5DD",
        borderRadius: "8px",
      },
    },
    "& .MuiInputBase-input": {
      color: "#667085",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#667085",
    },
    "& input[type=number]": {
      MozAppearance: "textfield",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
    },
  },
};

export default ItemInput;
